import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { SessionDetailPage } from '../session-detail/session-detail';

declare var dataLayer: Array<any>;

@Component({
  selector: 'page-speaker-detail',
  templateUrl: 'speaker-detail.html'
})
export class SpeakerDetailPage {
  speaker: any;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.speaker = this.navParams.data.speaker;
  }

  goToSessionDetail(session: any) {
    this.navCtrl.push(SessionDetailPage, { 
      name: session.name,
      session: session
    });

    dataLayer.push({
      'appEventCategory': 'speaker-detail',
      'appEventAction': 'goToSessionDetail',
      'appEventLabel': 'goToSessionDetail button'
    });
    dataLayer.push({'event': 'appEvent'});
  }


  ionViewDidLoad() {
    dataLayer.push({
      'screenPath': 'speaker-detail',
      'screenName': 'SpeakerDetailPage'
    });
    dataLayer.push({'event': 'appScreenView'});
  }
}



// WEBPACK FOOTER //
// ./src/pages/speaker-detail/speaker-detail.ts